var Backbone, SupportLiveChatModel, SupportUtilsHelper,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportUtilsHelper = require('../helpers/utils');

Backbone = require('backbone');

SupportLiveChatModel = (function(superClass) {
  extend(SupportLiveChatModel, superClass);

  function SupportLiveChatModel() {
    return SupportLiveChatModel.__super__.constructor.apply(this, arguments);
  }

  SupportLiveChatModel.prototype.initialize = function() {
    return this.setDefaults();
  };

  SupportLiveChatModel.prototype.setDefaults = function() {
    var attrs, ref, ref1;
    attrs = {
      userEmail: (ref = window.currentUser) != null ? ref.email : void 0,
      userName: SupportUtilsHelper.getCurrentUserFullName(),
      isLogged: ((ref1 = window.currentUser) != null ? ref1.email : void 0) != null,
      liveChat: window.liveChatInfo,
      initialQuestion: ""
    };
    return this.set(attrs, {
      slient: true
    });
  };

  SupportLiveChatModel.prototype.escapePunctuationsAndSanitize = function(text) {
    text = text.replace(/\\/g, "\\\\");
    text = text.replace(/\"/g, '\\"');
    return text = text.replace(/(<([^>]+)>)/ig, "");
  };

  SupportLiveChatModel.prototype.setIntialQuestion = function(params) {
    var currentOrder, initialQuestion, issue, ref, ref1;
    initialQuestion = [];
    if ((params != null ? params.issue : void 0) != null) {
      issue = this.escapePunctuationsAndSanitize(params.issue);
      initialQuestion.push((I18n.translate('js.modules.support.issue')) + " " + issue);
    }
    if (Groupon.Support.currentOrder) {
      currentOrder = Groupon.Support.currentOrder;
      if (isUS()) {
        initialQuestion.push((I18n.translate('js.modules.support.order_no')) + ": " + currentOrder.id);
      }
      if (currentOrder.deal != null) {
        initialQuestion.push((I18n.translate('js.modules.support.deal_concerned')) + " " + currentOrder.deal.id);
      }
      if (isIntl() && (((ref = currentOrder.groupons) != null ? (ref1 = ref[0]) != null ? ref1.redemptionCode : void 0 : void 0) != null)) {
        initialQuestion.push((I18n.translate('js.modules.support.security_code')) + ": " + currentOrder.groupons[0].redemptionCode);
      }
    }
    if (initialQuestion.length > 0) {
      initialQuestion.push("\\n");
      return this.set({
        initialQuestion: initialQuestion.join("\\n")
      });
    } else {
      return this.set({
        initialQuestion: ""
      });
    }
  };

  SupportLiveChatModel.prototype.setLiveChatInfo = function(liveChatType) {
    liveChatType = this.getLiveChatType(liveChatType);
    this.setLiveChatType(liveChatType);
    return this.setLiveChatCharacter(liveChatType);
  };

  SupportLiveChatModel.prototype.setLiveChatType = function(liveChatType) {
    var ref, ref1, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref2, ref20, ref21, ref22, ref23, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    switch (liveChatType) {
      case 'normal_live_chat':
        return this.set('liveChat', window.liveChatInfo);
      case 'optimized_live_chat':
        return this.set('liveChat', (ref = window.liveChatInfo) != null ? ref.optimizedBoldChat : void 0);
      case 'getaways_live_chat':
        return this.set('liveChat', (ref1 = window.liveChatInfo) != null ? ref1.getaways : void 0);
      case 'localbook_live_chat':
        return this.set('liveChat', (ref2 = window.liveChatInfo) != null ? ref2.localbook : void 0);
      case 'flexible_live_chat':
        return this.set('liveChat', (ref3 = window.liveChatInfo) != null ? ref3.flexibleBoldChat : void 0);
      case 'costco_live_chat':
        return this.set('liveChat', (ref4 = window.liveChatInfo) != null ? ref4.costco : void 0);
      case 'live_chat_link':
        return this.set('liveChat', (ref5 = window.liveChatInfo) != null ? ref5.linkBoldChat : void 0);
      case 'optimized_getaways_live_chat':
        return this.set('liveChat', (ref6 = window.liveChatInfo) != null ? (ref7 = ref6.optimizedBoldChat) != null ? ref7.getaways : void 0 : void 0);
      case 'optimized_localbook_live_chat':
        return this.set('liveChat', (ref8 = window.liveChatInfo) != null ? (ref9 = ref8.optimizedBoldChat) != null ? ref9.localbook : void 0 : void 0);
      case 'flexible_getaways_live_chat':
        return this.set('liveChat', (ref10 = window.liveChatInfo) != null ? (ref11 = ref10.flexibleBoldChat) != null ? ref11.getaways : void 0 : void 0);
      case 'flexible_costco_live_chat':
        return this.set('liveChat', (ref12 = window.liveChatInfo) != null ? (ref13 = ref12.flexibleBoldChat) != null ? ref13.costco : void 0 : void 0);
      case 'flexible_localbook_live_chat':
        return this.set('liveChat', (ref14 = window.liveChatInfo) != null ? (ref15 = ref14.flexibleBoldChat) != null ? ref15.localbook : void 0 : void 0);
      case 'flexible_v2_live_chat':
        return this.set('liveChat', (ref16 = window.liveChatInfo) != null ? (ref17 = ref16.flexibleBoldChat) != null ? ref17.v2 : void 0 : void 0);
      case 'live_chat_getaways_link':
        return this.set('liveChat', (ref18 = window.liveChatInfo) != null ? (ref19 = ref18.linkBoldChat) != null ? ref19.getaways : void 0 : void 0);
      case 'live_chat_localbook_link':
        return this.set('liveChat', (ref20 = window.liveChatInfo) != null ? (ref21 = ref20.linkBoldChat) != null ? ref21.localbook : void 0 : void 0);
      case 'live_chat_costco_link':
        return this.set('liveChat', (ref22 = window.liveChatInfo) != null ? (ref23 = ref22.linkBoldChat) != null ? ref23.costco : void 0 : void 0);
    }
  };

  SupportLiveChatModel.prototype.setLiveChatCharacter = function(liveChatType) {
    if (liveChatType === "live_chat_link" || liveChatType === "live_chat_getaways_link" || liveChatType === "live_chat_localbook_link" || liveChatType === "live_chat_costco_link") {
      return this.set("is_chat_link", true);
    } else {
      return this.set("is_chat_link", false);
    }
  };

  SupportLiveChatModel.prototype.getLiveChatType = function(liveChatType) {
    if (liveChatType != null) {
      return liveChatType;
    }
    if (this.shouldShowFlexibleLiveChat()) {
      return this.getFlexibleLiveChatType();
    } else if (this.shouldShowOptimizedLiveChat()) {
      return this.getOptimizedLiveChatType();
    } else {
      return this.getDefaultLiveChatType();
    }
  };

  SupportLiveChatModel.prototype.shouldShowOptimizedLiveChat = function() {
    return window.shouldShowOptimizedChannel();
  };

  SupportLiveChatModel.prototype.shouldShowFlexibleLiveChat = function() {
    return window.shouldShowFlexibleChannel();
  };

  SupportLiveChatModel.prototype.shouldShowGetawaysLiveChat = function() {
    return isCurrentOrderGetawaysDeal() && isUS();
  };

  SupportLiveChatModel.prototype.shouldShowCostcoLiveChat = function() {
    return window.isCostcoDeal();
  };

  SupportLiveChatModel.prototype.shouldShowLocalbookLiveChat = function() {
    var ref;
    return (ref = Groupon.Support.currentOrder) != null ? ref.isLocalbook : void 0;
  };

  SupportLiveChatModel.prototype.getDefaultStepTwoLiveChatMode = function() {
    var ref, ref1;
    return (ref = window.liveChatInfo) != null ? (ref1 = ref.mode) != null ? ref1.step_two : void 0 : void 0;
  };

  SupportLiveChatModel.prototype.getDefaultStepThreeLiveChatMode = function() {
    var ref, ref1;
    return (ref = window.liveChatInfo) != null ? (ref1 = ref.mode) != null ? ref1.step_three : void 0 : void 0;
  };

  SupportLiveChatModel.prototype.getDefaultLiveChatType = function() {
    if (this.shouldShowGetawaysLiveChat()) {
      return 'getaways_live_chat';
    } else if (this.shouldShowLocalbookLiveChat()) {
      return 'localbook_live_chat';
    } else if (this.shouldShowCostcoLiveChat()) {
      return 'costco_live_chat';
    } else {
      return 'normal_live_chat';
    }
  };

  SupportLiveChatModel.prototype.getOptimizedLiveChatType = function() {
    if (this.shouldShowGetawaysLiveChat()) {
      return 'optimized_getaways_live_chat';
    } else if (this.shouldShowLocalbookLiveChat()) {
      return 'optimized_localbook_live_chat';
    } else {
      return 'optimized_live_chat';
    }
  };

  SupportLiveChatModel.prototype.getFlexibleLiveChatType = function() {
    if (this.shouldShowGetawaysLiveChat()) {
      return 'flexible_getaways_live_chat';
    } else if (this.shouldShowLocalbookLiveChat()) {
      return 'flexible_localbook_live_chat';
    } else if (this.shouldShowCostcoLiveChat()) {
      return 'flexible_costco_live_chat';
    } else {
      return 'flexible_live_chat';
    }
  };

  SupportLiveChatModel.prototype.getFlexibleV2LiveChatType = function() {
    return 'flexible_v2_live_chat';
  };

  SupportLiveChatModel.prototype.getLinkLiveChatType = function() {
    if (this.shouldShowGetawaysLiveChat()) {
      return 'live_chat_getaways_link';
    } else if (this.shouldShowLocalbookLiveChat()) {
      return 'live_chat_localbook_link';
    } else if (this.shouldShowCostcoLiveChat()) {
      return 'live_chat_costco_link';
    } else {
      return 'live_chat_link';
    }
  };

  SupportLiveChatModel.prototype.shouldShowStepTwoLiveChat = function() {
    var liveChatmode;
    liveChatmode = this.getDefaultStepTwoLiveChatMode();
    return (liveChatmode != null) && isFloatingLiveChat(liveChatmode);
  };

  SupportLiveChatModel.prototype.isLiveChatEnabled = function() {
    return Groupon.Support.FeatureFlagModel.isShowLiveChatEnabled() && !(_.isEmpty(window.liveChatInfo));
  };

  return SupportLiveChatModel;

})(Backbone.Model);

module.exports = SupportLiveChatModel;

//# sourceMappingURL=data:application/json;base64,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
